<template>
  <div>
    <template-chart :items="myItems" :yyyy="yyyy"></template-chart>
  </div>
</template>

<script>
export default {
  props: ['item', 'yyyy', 'mm', 'value', 'group', 'prev', 'plan'],
  computed: {
    headers () {
      var temp = []
      temp.push({ title: '面談アポ率', id: 'calc_kpis_1', key: 4, align: 'start', calc: 'ave' })
      temp.push({ title: '体験入会率', id: 'calc_kpis_3', key: 6, align: 'end', calc: 'ave' })
      temp.push({ title: '入会率', id: 'calc_kpis_1', key: 6, align: 'end', calc: 'ave' })
      return temp
    },
    myItems () {
      var temp = []
      var acts = []
      for (var i in this.headers) {
        var values = this.item[this.headers[i].id][this.yyyy][this.group].map(v => {
          return v[this.headers[i].key]
        })
        acts.push({
          'key': this.headers[i].key + this.headers[i].id,
          'title': this.headers[i].title,
          'align': 'start',
          'values': values,
          'sum': this.item[this.headers[i].id + '_sum'][this.yyyy][this.group][2][this.headers[i].key],
          'prefix': '',
          'suffix': '%',
          'color': '#F8BBD080',
          'calc': 'ave'
        })
      }
      var prevs = []
      if (this.prev) {
        var prev = this.yyyy - 1
        if (prev >= 2018) {
          for (i in acts) {
            values = this.item[this.headers[i].id][prev][this.group].map((v) => {
              return v[this.headers[i].key]
            })
            prevs.push({
              'key': 'prev' + this.headers[i].key + this.headers[i].id,
              'title': '昨年',
              'align': 'end',
              'values': values,
              'sum': this.item[this.headers[i].id + '_sum'][prev][this.group][2][this.headers[i].key],
              'prefix': '',
              'suffix': '%',
              'color': '',
              'calc': 'ave'
            })
          }
        }
      }
      for (i in acts) {
        temp.push(acts[i])
        if (prevs.length !== 0) {
          temp.push(prevs[i])
        }
      }
      return temp
    }
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style scoped>
</style>
